module.exports = __webpack_public_path__ + "media/images/avatar-4eff55309223839f16ab91b833928e1e.png";